<template>
  <div :class="['asc-page-header', !$slots.pageActions ? 'noActions' : null]">
    <v-row no-gutters>
      <v-col cols="8">
        <slot name="pageTitle"></slot>
      </v-col>
      <v-col class="pageActions" cols="4">
        <slot name="pageActions"> </slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'AscPageHeader',
}
</script>

<style lang="scss">
.asc-page-header {
  margin: 10px 0 20px 0;
  min-height: 32px;

  &.noActions {
    margin-bottom: 8px;
  }

  > .row {
    align-items: baseline;
  }
}
</style>
